/**
 * 商品页链接（产品 / 采购行 / 物料申请共用，main-api `link_schema.LinkItem`）。
 * 数组顺序 = 优先顺序：第一条是默认链接。`vendor` 只是显示名，不关联 vendor 表；
 * 没填时后端写入前按域名带出。写入整列替换：`null` 不改，`[]` 清空，最多 10 条。
 */
export interface LinkItem {
  url: string
  vendor?: string | null
  note?: string | null
}

export const MAX_LINKS = 10
